import request from '@/utils/request'
// 查询统计数据分页
export function fetchTaskStatistics(query) {
    return request({
        url: '/user/task-statistics/task-total',
        method: 'get',
        params: query
    })
}

export function fetchTaskDetailList (query) {
    return request({
        url: '/user/task-statistics/task-detail',
        method: 'get',
        params: query
    })
}
